import { render, staticRenderFns } from "./ekko.default-hero.vue?vue&type=template&id=577640b6&scoped=true&"
import script from "./ekko.default-hero.vue?vue&type=script&lang=ts&"
export * from "./ekko.default-hero.vue?vue&type=script&lang=ts&"
import style0 from "./ekko.default-hero.vue?vue&type=style&index=0&id=577640b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577640b6",
  null
  
)

export default component.exports